module.exports = __webpack_public_path__ + "img/img-header-min.9ff6a38.png";